import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/supply-chain-mapping')({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/supply-chain-mapping' ||
      location.pathname === '/supply-chain-mapping/'
    ) {
      throw redirect({ to: '/supply-chain-mapping/supply-chains/active' });
    }
  },
});
